"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItem = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const cotopaxi_1 = require("@as/cotopaxi");
const common_types_1 = require("@as-react/common-types");
const common_components_1 = require("@as-react/common-components");
const react_i18next_1 = require("react-i18next");
const i18nConstants_1 = require("../../../constants/i18nConstants");
const ImageUtil_1 = require("../../../util/ImageUtil");
const ProductUtil_1 = require("../../../util/ProductUtil");
const DeliveryPromiseMessage_1 = tslib_1.__importDefault(require("../../product-detail/delivery-promise/DeliveryPromiseMessage"));
const CartItemSizeSelect_1 = require("./CartItemSizeSelect");
const DeliveryPromiseUtil_1 = require("../../../util/DeliveryPromiseUtil");
const BasketActions_creators_1 = require("../../../redux/basket/actions/BasketActions.creators");
const react_redux_1 = require("react-redux");
const WishListSelectors_1 = require("../../../redux/wishList/selectors/WishListSelectors");
const HtmlElementUtil_1 = require("../../../util/HtmlElementUtil");
const WishListUtil_1 = require("../../../util/WishListUtil");
const WishListActions_creators_1 = require("../../../redux/wishList/actions/WishListActions.creators");
const asNumeral_1 = require("../../../vendors/asNumeral");
const common_utils_1 = require("@as-react/common-utils");
const BasketSelector_1 = require("../../../redux/basket/selectors/BasketSelector");
const ProductConstants_1 = require("../../../constants/ProductConstants");
const usePriceProps_1 = require("../../../hooks/usePriceProps");
const andes_react_1 = require("@yonderland/andes-react");
const CART_ITEM_IMAGE_DIMENSIONS = {
    mobile: {
        width: 80,
        height: 120,
    },
    tablet: {
        width: 120,
        height: 180,
    },
};
const CartItem = ({ product, deliveryPromiseExplanations, showDeliveryPromise }) => {
    var _a, _b, _c, _d;
    const [quantity, setQuantity] = (0, react_1.useState)(product.quantity);
    const [wishlistAnimate, setWishlistAnimate] = (0, react_1.useState)(false);
    const dispatch = (0, react_redux_1.useDispatch)();
    const isWishlistProduct = (0, react_redux_1.useSelector)((0, WishListSelectors_1.makeIsProductInWishList)(product.productCode, product.colorId));
    const isBasketLocked = (0, react_redux_1.useSelector)((0, BasketSelector_1.makeGetBasketLockState)());
    const { t } = (0, react_i18next_1.useTranslation)([i18nConstants_1.I18N_NAMESPACES.navigation, i18nConstants_1.I18N_NAMESPACES.checkout]);
    const isDesktop = (0, cotopaxi_1.useMediaQueryMatchesOnDesktop)();
    const { currency, isShopLanding, root, productImageConfig, feature_toggles: { lowest_price_all }, } = (0, common_components_1.useAemConfig)();
    (0, react_1.useEffect)(() => {
        if (quantity !== product.quantity) {
            setQuantity(product.quantity);
        }
    }, [product, quantity]);
    const getRequestObject = (quantityParam) => ({
        quantity: quantityParam,
        sku: String(product.sku),
        productId: String(product.productId),
        colorId: product.colorId,
        productCode: product.productCode,
        productPriceManual: product.priceManual,
        additionalProperties: product.additionalProperties,
    });
    const handleUpdateProductQuantity = (quantityParam) => {
        setQuantity(quantityParam);
        dispatch(BasketActions_creators_1.basketActions.createUpdateQuantityCustomAction(getRequestObject(quantityParam)));
    };
    const handleIncreaseProductQuantity = (quantityParam) => {
        setQuantity(quantityParam);
        dispatch(BasketActions_creators_1.basketActions.createIncreaseProductQuantityAction(getRequestObject(1)));
    };
    const handleDecreaseProductQuantity = (quantityParam) => {
        setQuantity(quantityParam);
        if (quantityParam > 0) {
            dispatch(BasketActions_creators_1.basketActions.createDecreaseProductQuantityAction(getRequestObject(1)));
        }
        else {
            handleRemoveProduct();
        }
    };
    const handleRemoveProduct = () => {
        dispatch(BasketActions_creators_1.basketActions.createRemoveProductAndUpdate(getRequestObject(product.quantity)));
    };
    const handleSizeChange = (sku) => {
        if (String(product.sku) !== sku) {
            dispatch(BasketActions_creators_1.basketActions.createChangeSizeAction(getRequestObject(product.quantity), sku));
        }
    };
    const toggleWishList = () => {
        dispatch(WishListActions_creators_1.wishListActions.toggleProduct({
            productId: Number(product.productId),
            productCode: product.productCode,
            colorId: product.colorId,
            sku: product.sku,
        }));
        setWishlistAnimate(!WishListUtil_1.isProductInWishList);
        !isDesktop && (0, HtmlElementUtil_1.showMobileHeader)();
    };
    const productDetailUrl = (0, ProductUtil_1.getProductDetailUrl)({
        seoUrl: product.seoUrl,
        colourId: product.colorId,
    }, root);
    const getDeliveryPromise = () => {
        var _a;
        if (!showDeliveryPromise)
            return null;
        if (product.productType === common_types_1.ProductTypes.E_VOUCHER) {
            return t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.mailbox`);
        }
        if (!product.additionalProperties)
            return null;
        const { additionalProperties } = product;
        return additionalProperties.deliveryPromiseCutoff ? ((0, jsx_runtime_1.jsx)(DeliveryPromiseMessage_1.default, { deliveryPromise: {
                cutoff: additionalProperties.deliveryPromiseCutoff,
                deliveryMessage: additionalProperties.deliveryMessage,
                hasDeliveryMessage: (_a = additionalProperties.hasDeliveryMessage) !== null && _a !== void 0 ? _a : !!additionalProperties.deliveryMessage,
                name: additionalProperties.deliveryOptionName,
            } })) : (additionalProperties.deliveryMessage);
    };
    const productAlt = [product.brand, product.description, product.colorDescription].join(' ');
    const discountAmount = asNumeral_1.AsNumeral.getInstance().formatAsCurrency(product.totalProductDiscountAmount);
    const priceActual = {
        formattedPrice: asNumeral_1.AsNumeral.getInstance().formatAsCurrency(product.price),
    };
    const pricePrevious = product.productHasDiscount && !!product.previousPrice
        ? {
            formattedPrice: asNumeral_1.AsNumeral.getInstance().formatAsCurrency(product.previousPrice),
            priceLabel: ((_a = product.prices) === null || _a === void 0 ? void 0 : _a.RRP) ? t(`${i18nConstants_1.I18N_NAMESPACES.product}:product.price.rrp`) : undefined,
        }
        : undefined;
    const priceReference = product.productHasDiscount && !!product.lowestPrice
        ? {
            formattedPrice: asNumeral_1.AsNumeral.getInstance().formatAsCurrency(product.lowestPrice),
        }
        : undefined;
    const priceProps = (0, usePriceProps_1.usePriceProps)({
        priceInformation: {
            prices: product.prices,
            hasDiscount: (_b = product.productHasDiscount) !== null && _b !== void 0 ? _b : false,
        },
        enablePriceReference: lowest_price_all,
        fallbackPriceViewModel: {
            priceActual,
            pricePrevious,
            priceReference,
        },
    });
    const productContext = {
        productCode: product.productCode,
        productId: Number(product.productId),
        activeColorId: product.colorId,
        brand: product.brand,
        title: product.description,
        image: product.additionalImage
            ? product.additionalImage
            : (0, ImageUtil_1.getImageSourceSetByProductCode)(product.productCode, product.image, productImageConfig)[common_types_1.ProductImageSizesPortraitEnum.basket],
        alt: productAlt,
        colors: [],
    };
    const deliveryPromise = getDeliveryPromise();
    const deliveryPromiseExplanation = product.productType !== common_types_1.ProductTypes.E_VOUCHER
        ? (0, DeliveryPromiseUtil_1.getDeliveryExplanation)({ stockLocation: (_c = product.additionalProperties) === null || _c === void 0 ? void 0 : _c.stockLocation }, deliveryPromiseExplanations)
        : undefined;
    return ((0, jsx_runtime_1.jsxs)(cotopaxi_1.ProductTile, { variant: "horizontal", product: productContext, children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Area, { area: "primary", children: (0, jsx_runtime_1.jsx)(cotopaxi_1.Link, { href: productDetailUrl, title: productAlt, variant: cotopaxi_1.LinkVariant.CONTAINER, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Image, { dataQA: "basket_checkout_item_image", width: ProductConstants_1.ProductImageWidth.BASKET, height: ProductConstants_1.ProductImageHeight.BASKET, containerOptions: {
                            mobile: Object.assign({ spacing: { marginRight: 3 } }, CART_ITEM_IMAGE_DIMENSIONS.mobile),
                            tablet: CART_ITEM_IMAGE_DIMENSIONS.tablet,
                        } }) }) }), (0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Area, { area: "secondary", children: (0, jsx_runtime_1.jsxs)(cotopaxi_1.Grid, { columns: { tablet: 3 }, rows: 2, gap: { mobile: 'm' }, children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.GridItem, { column: { tablet: { start: 1, end: 'span 2' } }, children: (0, jsx_runtime_1.jsxs)(cotopaxi_1.Group, { column: true, gutter: { mobile: 2, tablet: 4 }, children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Info, { containerOptions: { mobile: { spacing: { marginBottom: 1 } } }, children: (0, jsx_runtime_1.jsx)(cotopaxi_1.Link, { href: productDetailUrl, title: productAlt, variant: cotopaxi_1.LinkVariant.CONTAINER, dataQA: "product_title", children: (0, jsx_runtime_1.jsx)(cotopaxi_1.ProductTile.Title, { brandOnTheSameLine: true }) }) }), (0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { dataQA: "product_color", children: t(`${i18nConstants_1.I18N_NAMESPACES.navigation}:basket.flyout.options.color`, {
                                                    color: product.color,
                                                }) })] }), (0, jsx_runtime_1.jsxs)(cotopaxi_1.Group, { column: true, gutter: { mobile: 1.5 }, children: [Boolean(deliveryPromise) && ((0, jsx_runtime_1.jsxs)(cotopaxi_1.Box, { children: [typeof deliveryPromise === 'string' ? ((0, jsx_runtime_1.jsx)(cotopaxi_1.Text, { inline: true, color: cotopaxi_1.TextColor.POSITIVE, size: cotopaxi_1.TextSize.SMALL, children: deliveryPromise })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: deliveryPromise })), deliveryPromiseExplanation && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' ', (0, jsx_runtime_1.jsx)(cotopaxi_1.Icon, { id: `delivery-item-explanation-${product.productId}${product.sku ? '-' + product.sku : ''}`, size: cotopaxi_1.IconSize.MINOR, color: cotopaxi_1.IconColor.POSITIVE, name: cotopaxi_1.IconName.INFORMATION_OUTLINE, dynamicContent: deliveryPromiseExplanation, inline: true })] }))] })), (0, jsx_runtime_1.jsx)(CartItemSizeSelect_1.CartItemSizeSelect, { product: product, onSizeChange: handleSizeChange, disabled: isBasketLocked })] })] }) }), (0, jsx_runtime_1.jsx)(cotopaxi_1.GridItem, { children: (0, jsx_runtime_1.jsxs)(cotopaxi_1.Group, { column: true, valign: { tablet: cotopaxi_1.GroupVerticalAlign.BOTTOM }, gutter: cotopaxi_1.GroupGutter.MEDIUM, children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.ControlledNumberInput, { id: product.productId, quantity: quantity, onUpdate: handleUpdateProductQuantity, onDecrease: handleDecreaseProductQuantity, onIncrease: handleIncreaseProductQuantity, isDisabled: isBasketLocked }), !!priceProps && ((0, jsx_runtime_1.jsx)(andes_react_1.Price, Object.assign({}, priceProps, { caveat: !!product.productHasDiscount && (0, common_utils_1.showPriceDiscount)(product.prices, lowest_price_all)
                                            ? {
                                                text: `${t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.basket.discount.label`)} ${currency}${discountAmount} / ${(_d = product.productDiscountPercentage) === null || _d === void 0 ? void 0 : _d.toString()}%`,
                                                isCommercial: true,
                                            }
                                            : undefined, align: "end" })))] }) }), (0, jsx_runtime_1.jsx)(cotopaxi_1.GridItem, { column: { tablet: { start: 1, end: 'span 3' } }, children: (0, jsx_runtime_1.jsxs)(cotopaxi_1.Group, { gutter: 1.5, children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.Button, { className: "as-m-cart-item__remove-btn", variant: cotopaxi_1.ButtonVariant.LINK_SUBTLE, size: cotopaxi_1.ButtonSize.SMALL, iconLeft: { name: cotopaxi_1.IconName.TRASH, size: cotopaxi_1.IconSize.EXTRA_MINOR }, text: t(`${i18nConstants_1.I18N_NAMESPACES.account}:delivery.delete`), onClick: handleRemoveProduct, dataQA: "remove_product", state: isBasketLocked ? cotopaxi_1.ButtonState.DISABLED : undefined }), !isShopLanding && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(cotopaxi_1.Divider, { className: "as-m-cart-item__divider", type: cotopaxi_1.DividerType.VERTICAL }), (0, jsx_runtime_1.jsx)(cotopaxi_1.Button, { className: "as-m-cart-item__wishlist-btn", variant: cotopaxi_1.ButtonVariant.LINK_SUBTLE, size: cotopaxi_1.ButtonSize.SMALL, iconLeft: {
                                                    color: cotopaxi_1.IconColor.ACTION,
                                                    size: cotopaxi_1.IconSize.EXTRA_MINOR,
                                                    name: isWishlistProduct ? cotopaxi_1.IconName.HEART : cotopaxi_1.IconName.HEART_EMPTY,
                                                    animation: wishlistAnimate ? cotopaxi_1.IconAnimation.HEART_PULSE : undefined,
                                                }, text: isWishlistProduct
                                                    ? t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.basket.wishlist.remove`)
                                                    : t(`${i18nConstants_1.I18N_NAMESPACES.checkout}:checkout.basket.wishlist.add`), onClick: toggleWishList })] }))] }) })] }) })] }));
};
exports.CartItem = CartItem;
